import { request } from "../base/HTTP";
import HttpMethod from "../constants/HttpMethod";
import CONFIG from '../config';

export async function getOffer(id) {

    if (!id) {
        return;
    }

    return await request('/api/offer/' + id, {}, HttpMethod.GET);
}

export async function makeOffer(id) {
    const confDiv = CONFIG.currentDivision;
    let currDivision;
    switch (confDiv) {
        case 'ss':
            currDivision = 0;
          break;
        case 'st':
            currDivision = 1;
          break;
        case 'sc':
            currDivision = 2;
          break;
        default:
            currDivision = 1;
          break;
      }
     
      let data = {
        currentDivision: currDivision
      };
    return await request('/api/application/make-offer/' + id, data , HttpMethod.PUT);
}

export async function changeHRApprovalStatus(data) {
    return await request('/api/offer/hrapproval' , data, HttpMethod.POST);
}

export async function sendOffer(id, data) {

    if (!id) {
        return;
    }

    return await request('/api/offer/' + id, transformData(data), HttpMethod.POST);
}

function setDate(inputDate) {
    let date = new Date(inputDate);
    date.setHours(12);
    date.setMinutes(0);

    return date;
}

function transformData(data) {

    const toBoolean = (input) => {
        if (input === undefined || input === null || input === '') {
            return false;
        }
        // Object coming from select { value: true/false, name: 'Yes/No' }
        if (typeof input === 'object' && input.value !== undefined) {
            return !!input.value;
        }
        if (typeof input === 'string') {
            const lower = input.trim().toLowerCase();
            if (lower === 'true') return true;
            if (lower === 'false') return false;
            // any non-empty string treat as false by default for these flags
            return false;
        }
        return !!input;
    }

    return {
        ...data,
        contractedHoursPerMonth: data.contractedHoursPerMonth ? data.contractedHoursPerMonth.name : '',
        hoursPerWeek: data.hoursPerWeek ? data.hoursPerWeek.name : '',
        currency: data.currency ? data.currency.name : '',
        commission: toBoolean(data.commission),
        bonus: toBoolean(data.bonus),
        carAllowance: toBoolean(data.carAllowance),
        healthcare: toBoolean(data.healthcare),
        startDate: data.startDate ? setDate(data.startDate) : new Date(Date.now()),
        continuousStartDate: data.continuousStartDate ? setDate(data.continuousStartDate) : new Date(Date.now()),
    }
}